import React, {useState} from 'react';
import {View, Text, StyleSheet, TouchableOpacity, FlatList} from 'react-native';
import Width from '../../../assets/Width';
import ClubImageCard from './clubImageCard';
import ClubMarketOptions from './clubMarketOptions';
import ClubOptionsForm from './clubOptionsForm';
import ClubOrderStatus from './clubOrderStatus';
import ClubOptionsSettle from './ClubOptionsSettle';
import ClubOptionsSettleConfirm from './ClubOptionsSettleConfirm';

const ClubOptionsBottomComponent = ({
  selectedOption,
  onOptionClick,
  orderStatusHandler,
  clubEventDetails,
  isOwner,
  settleOrderHandler,
  onBottomSheetClose,
}) => {
  const [optionsChanges, setOptionsChanges] = useState(
    clubEventDetails?.options || [],
  );

  const onDifferentOptions = updatedOptions => {
    setOptionsChanges(updatedOptions?.data);
  };

  const ClubSettleConfirmComponent = () => {
    return (
      <ClubOptionsSettleConfirm
        orderStatus={orderStatusHandler}
        clubEventDetails={{
          ...clubEventDetails,
          options: optionsChanges,
        }}
        optionSelectedIndex={selectedOption?.optionIndex}
      />
    );
  };

  const ClubSettleComponent = () => {
    return (
      <>
        {!selectedOption.isSettleConfirmation ? (
          <>
            <ClubImageCard
              isForm={true}
              title={clubEventDetails?.title}
              titleImg={clubEventDetails?.image_url}
            />
            <ClubMarketOptions
              onOptionClick={onOptionClick}
              isForm={true}
              optionSelectedIndex={selectedOption?.optionsData?.id}
              clubmarketOptions={optionsChanges}
              isOwner={isOwner}
            />
            <ClubOptionsSettle
              orderStatus={orderStatusHandler}
              clubEventDetails={{
                ...clubEventDetails,
                options: optionsChanges,
              }}
              onDifferentOptions={onDifferentOptions}
              optionSelectedIndex={selectedOption?.optionIndex}
            />
          </>
        ) : (
          <>{ClubSettleConfirmComponent()}</>
        )}
      </>
    );
  };

  const ClubBid = () => {
    return (
      <View>
        <ClubImageCard
          isForm={true}
          title={clubEventDetails?.title}
          titleImg={clubEventDetails?.image_url}
        />
        <ClubMarketOptions
          onOptionClick={onOptionClick}
          isForm={true}
          optionSelectedIndex={selectedOption?.optionsData?.id}
          clubmarketOptions={optionsChanges}
          isOwner={isOwner}
        />
        <ClubOptionsForm
          orderStatus={orderStatusHandler}
          clubEventDetails={{
            ...clubEventDetails,
            options: optionsChanges,
          }}
          onDifferentOptions={onDifferentOptions}
          optionSelectedIndex={selectedOption?.optionIndex}
          onBottomSheetClose={onBottomSheetClose}
        />
      </View>
    );
  };
  return (
    <View style={{width: Width.width, paddingHorizontal: 12, marginTop: 40}}>
      {!selectedOption?.clubOrderResponse ? (
        selectedOption && (
          <View>
            {selectedOption.isShowSettle ? (
              <>{ClubSettleComponent()}</>
            ) : (
              <>{ClubBid()}</>
            )}
          </View>
        )
      ) : (
        <ClubOrderStatus
          clubOrderResponse={selectedOption?.clubOrderResponse}
          onDoneClick={orderStatusHandler}
          settleOrderHandler={settleOrderHandler}
        />
      )}
    </View>
  );
};

export default ClubOptionsBottomComponent;
